module.exports = __webpack_public_path__ + "app/components/alerts/alerts.view.html";